module.exports = __webpack_public_path__ + "img/Unidad20-2.77779278.png";